import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_FILE_UPLOAD_FAILED = `${PhotoCapture.PHOTO_CAPTURE}_FILE_UPLOAD_FAILED`;
export const PHOTO_CAPTURE_INVALID_FILE_UPLOAD = `${PhotoCapture.PHOTO_CAPTURE}_INVALID_FILE_UPLOAD`;
export const photoCaptureFileUploadFailedAction = () => ({
    type: PHOTO_CAPTURE_FILE_UPLOAD_FAILED,
    payload: null
});
export const photoCaptureInvalidFileUploadAction = (errorData) => ({
    type: PHOTO_CAPTURE_INVALID_FILE_UPLOAD,
    payload: { errorData }
});
//# sourceMappingURL=photoCaptureFileUploadFailedAction.js.map